<div class="db-schedule">
  <div class="db-schedule-body">
    <div class="db-schedule-slider">
      <div class="db-schedule-slider-title">
        {{title}}
      </div>
      <div class="slider-title-wrap">
        <div class="sl-scheduling-param-period-label" [ngClass]="{'active': i === slider}" (click)="setSliderValue(i)" *ngFor="let sliderValue of sliderValues; let i = index">{{sliderValue.title}}</div>
      </div>
      <nouislider class="step-slider" name="slider" [min]="0" [max]="2" [step]="1" [connect]="false" [(ngModel)]="slider" (ngModelChange)="onChange($event)"></nouislider>

    </div>
    <div class="settings-title">{{'text_scheduleSettingsTitle' | dbText}}</div>
    <div class="settings-wrap">
      <div class="settings-options">
        <div class="settings-option-label">{{'text_settingsStartTime' | dbText}}</div>
        <div class="settings-option-select">
          <db-fc-dropdown-select [positionCLassName]="'db-fc-dropdown-select__content_on_t'" [formControl]="settingsStartTime" [value]="settingsStartTime.value" [options]="settingsStartTimeOptions"></db-fc-dropdown-select>
        </div>
      </div>
      <div class="settings-options last-child" *ngIf="slider === 0">
        <div class="settings-option-label date-label">{{'text_date' | dbText}}</div>
        <div class="settings-option-select">
          <db-fc-dropdown-select [positionCLassName]="'db-fc-dropdown-select__content_on_t'" [formControl]="settingsMonthDay" [value]="settingsMonthDay.value" [options]="settingsMonthDayOptions"></db-fc-dropdown-select>
        </div>
      </div>
      <div class="settings-options last-child" *ngIf="slider === 1">
        <div class="settings-option-label weekday-label">{{'text_settingsWeekDay' | dbText}}</div>
        <div class="settings-option-select weekday-select">
          <db-fc-dropdown-select [positionCLassName]="'db-fc-dropdown-select__content_on_t'" [formControl]="settingsWeekDay" [value]="settingsWeekDay.value" [options]="settingsWeekDayOptions"></db-fc-dropdown-select>
        </div>
      </div>
      <div class="settings-desc">{{'text_settingsDesc' | dbText}}</div>

    </div>

  </div>
</div>
